/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DMSAuthUrlResponseDto interface.
 */
export function instanceOfDMSAuthUrlResponseDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    return true;
}
export function DMSAuthUrlResponseDtoFromJSON(json) {
    return DMSAuthUrlResponseDtoFromJSONTyped(json, false);
}
export function DMSAuthUrlResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
    };
}
export function DMSAuthUrlResponseDtoToJSON(json) {
    return DMSAuthUrlResponseDtoToJSONTyped(json, false);
}
export function DMSAuthUrlResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
    };
}
